import React, { useState, useRef, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { NotifyApi, MakerChartreport, previewrdmdata } from "../components/ApiProperty";
import greenbg from '../assets/images/Yellow.png';
import loadingGif from '../assets/images/Loading-Animation.gif';
import { Modal, Button, Form } from 'react-bootstrap';


import {
    Chart,
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
} from "chart.js";
import axios from "axios";
import { useSession } from '../components/SessionContext';

Chart.register(
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
);
const Mdashboard = () => {
    const createdTemplateChartRef = useRef(null);
    const createdTemplateChartInstance = useRef(null);
    const [selectedBarData, setSelectedBarData] = useState(null);
    const [showChart, setShowChart] = useState(true);
    const [showDueAlertModal, setShowDueAlertModal] = useState(false);
    const [dueAlertMessage, setDueAlertMessage] = useState("");
    const [showDoughnut, setShowDoughnut] = useState(true);
    const location = useLocation();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const chartInitializedRef = useRef(false);
    const [reloadChart, setReloadChart] = useState(false);
    const [selectedRange, setSelectedRange] = useState("All");
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const chartContainerRef = useRef(null);
    const [dateFilter, setDateFilter] = useState("all");
    const [submittedTables, setSubmittedTables] = useState([]);
    const [modifiedTables, setModifiedTables] = useState([]);
    const [modalMessage, setModalMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'
    const [isEmptySummary, setIsEmptySummary] = useState(false);
    const [chartDataReady, setChartDataReady] = useState(false);
    const [allDepartmentsData, setAllDepartmentsData] = useState(null);
    const doughnutChartDataRef = useRef(null);
    const userRole = localStorage.getItem("userRole");
    const dept = localStorage.getItem("dept");



    // =========== Start the Generate the Maker Report ====================


    const frequencyMonths = {
        Monthly: 1,
        Quarterly: 3,
        Quartely: 3,   // ✅ add this
        HalfYearly: 6,
        Yearly: 12
    };

    // const checkUploadDueDate = async () => {
    //     try {
    //         const csrfToken = sessionStorage.getItem("tokenizedSession");

    //         const config = {
    //             headers: {
    //                 userId: localStorage.getItem("userid"),
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //             params: {
    //                 tableName: `Finance_return_on_equity_temp`,
    //                 dataModel: "DEM"
    //             }
    //         };

    //         const apiResponse = await axios.post(previewrdmdata, {}, config);

    //         if (!apiResponse.data?.fileName) return;

    //         const fetchedFileName = apiResponse.data.fileName;

    //         const dataResponse = await fetch(`/jsonfiles/Finance_return_on_equity_temp.json`);
    //         if (!dataResponse.ok) return;

    //         const jsonData = await dataResponse.json();

    //         if (!jsonData.length) return;

    //         //  Get latest reporting date
    //         const latestRecord = jsonData.reduce((latest, current) => {
    //             return new Date(current.reporting_date) > new Date(latest.reporting_date)
    //                 ? current
    //                 : latest;
    //         });

    //         const reportingDate = new Date(latestRecord.reporting_date);
    //         const frequency = latestRecord.frequency;

    //         const monthsToAdd = frequencyMonths[frequency];
    //         if (!monthsToAdd) return;

    //         const nextDueDate = new Date(reportingDate);
    //         nextDueDate.setMonth(nextDueDate.getMonth() + monthsToAdd);

    //         const today = new Date();

    //         console.log("Reporting Date:", reportingDate);
    //         console.log("Next Due Date:", nextDueDate);
    //         console.log("Today:", today);

    //         if (today > nextDueDate) {
    //             // setDueAlertMessage(
    //             //     `Data Upload pending for Return on equity. Last reporting date was ${latestRecord.reporting_date}.`
    //             // );
    //             setDueAlertMessage(
    //                 `Data Upload pending for Return on equity. Last reporting date was ${latestRecord.reporting_date}.`
    //             );
    //             setShowDueAlertModal(true);
    //         }

    //     } catch (error) {
    //         console.error("Error checking upload due date:", error);
    //     }
    // };


    // const checkUploadDueDate = async () => {
    //     try {
    //         const csrfToken = sessionStorage.getItem("tokenizedSession");

    //         const config = {
    //             headers: {
    //                 userId: localStorage.getItem("userid"),
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true,
    //             params: {
    //                 tableName: `Finance_return_on_equity_temp`,
    //                 dataModel: "DEM"
    //             }
    //         };

    //         // 🔹 Call API (TEMP)
    //         const apiResponse = await axios.post(previewrdmdata, {}, config);

    //         // 🔹 Fetch TEMP JSON
    //         const tempResponse = await fetch(`/jsonfiles/Finance_return_on_equity_temp.json`);
    //         const tempData = tempResponse.ok ? await tempResponse.json() : [];

    //         // 🔹 Fetch LIVE JSON
    //         const liveResponse = await fetch(`/jsonfiles/Finance_return_on_equity_live.json`);
    //         const liveData = liveResponse.ok ? await liveResponse.json() : [];

    //         // ✅ If BOTH are empty
    //         if ((!tempData || tempData.length === 0) &&
    //             (!liveData || liveData.length === 0)) {

    //             setDueAlertMessage(
    //                 `Return on Equity (RoE) data upload is pending since 16 Feb and overdue by 10 days`
    //             );
    //             setShowDueAlertModal(true);
    //             return;
    //         }

    //         // 🔹 Combine both (if needed)
    //         const combinedData = [...(tempData || []), ...(liveData || [])];

    //         if (!combinedData.length) return;

    //         // 🔹 Get latest reporting date
    //         const latestRecord = combinedData.reduce((latest, current) => {
    //             return new Date(current.reporting_date) > new Date(latest.reporting_date)
    //                 ? current
    //                 : latest;
    //         });

    //         const reportingDate = new Date(latestRecord.reporting_date);
    //         const frequency = latestRecord.frequency;

    //         const monthsToAdd = frequencyMonths[frequency];
    //         if (!monthsToAdd) return;

    //         const nextDueDate = new Date(reportingDate);
    //         nextDueDate.setMonth(nextDueDate.getMonth() + monthsToAdd);

    //         const today = new Date();

    //         console.log("Reporting Date:", reportingDate);
    //         console.log("Next Due Date:", nextDueDate);
    //         console.log("Today:", today);

    //         if (today > nextDueDate) {
    //             setDueAlertMessage(
    //                 `Data Upload pending for Return on equity. The next due date was ${nextDueDate.toLocaleDateString()}.`
    //             );
    //             setShowDueAlertModal(true);
    //         }

    //     } catch (error) {
    //         console.error("Error checking upload due date:", error);
    //     }
    // };

    const checkUploadDueDate = async () => {
        try {
            const userId = localStorage.getItem("userid");

            // ✅ Run ONLY for this template & this user
            if (
                userId !== "10189" ||
                `Finance_return_on_equity_temp` !== "Finance_return_on_equity_temp"
            ) {
                return; // 🚫 Exit for other users/templates
            }

            const csrfToken = sessionStorage.getItem("tokenizedSession");

            const config = {
                headers: {
                    userId: userId,
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: `Finance_return_on_equity_temp`,
                    dataModel: "DEM"
                }
            };

            await axios.post(previewrdmdata, {}, config);

            const tempResponse = await fetch(`/jsonfiles/Finance_return_on_equity_temp.json`);
            const tempData = tempResponse.ok ? await tempResponse.json() : [];

            const liveResponse = await fetch(`/jsonfiles/Finance_return_on_equity_live.json`);
            const liveData = liveResponse.ok ? await liveResponse.json() : [];

            // ✅ If BOTH empty
            if (tempData.length === 0 && liveData.length === 0) {
                setDueAlertMessage(
                    `Return on Equity (RoE) data upload is pending since 1 Mar and overdue by 10 days`
                );
                setShowDueAlertModal(true);
                return;
            }

            const combinedData = [...tempData, ...liveData];
            if (!combinedData.length) return;

            const latestRecord = combinedData.reduce((latest, current) => {
                return new Date(current.reporting_date) > new Date(latest.reporting_date)
                    ? current
                    : latest;
            });

            const reportingDate = new Date(latestRecord.reporting_date);
            const frequency = latestRecord.frequency;

            const monthsToAdd = frequencyMonths[frequency];
            if (!monthsToAdd) return;

            const nextDueDate = new Date(reportingDate);
            nextDueDate.setMonth(nextDueDate.getMonth() + monthsToAdd);

            const today = new Date();

            // if (today > nextDueDate) {
            //     const formattedDueDate = nextDueDate.toLocaleDateString("en-GB", {
            //         day: "2-digit",
            //         month: "short"
            //     });

            //     const overdueDays = Math.floor(
            //         (today - nextDueDate) / (1000 * 60 * 60 * 24)
            //     );

            //     setDueAlertMessage(
            //         `Return on Equity (RoE) data upload is pending since ${formattedDueDate} and overdue by ${overdueDays} days.`
            //     );
            //     setShowDueAlertModal(true);
            // }

        } catch (error) {
            console.error("Error checking upload due date:", error);
        }
    };

    useEffect(() => {
        const userRole = localStorage.getItem("userRole");
        const dept = localStorage.getItem("dept");
        const Activty = 'C';

        if (userRole !== "Maker") return;

        const fetchAllMakerTemplateDetails = async () => {
            setIsLoading(true);

            try {

                let csrfToken = sessionStorage.getItem("tokenizedSession");
                const config = {
                    headers: {
                        userId: localStorage.getItem("userid"),
                        "x-csrf-token": csrfToken
                    },

                    params: { userRole, dept, dateFilter, Activty },
                    withCredentials: true
                };

                const response = await axios.post(MakerChartreport, {}, config);
                const responseData = response.data || {};
                const allDepartmentData = responseData["data Information"] || {};

                setAllDepartmentsData(allDepartmentData);

                if (dept === "IT") {
                    setAllDepartmentsData(allDepartmentData);
                    setShowDoughnut(false); // explicitly turn off doughnut
                    // Prepare Doughnut Chart Data
                    const deptEntries = Object.entries(allDepartmentData || {});
                    const labels = [];
                    const submittedCounts = [];
                    const tooltipTableData = [];

                    deptEntries.forEach(([deptName, deptData]) => {
                        const submittedCount = deptData?.[0]?.["Submitted Table count"] || 0;
                        const submittedTables = deptData?.[0]?.["Submitted Tables"] || [];

                        if (submittedCount > 0) {
                            labels.push(deptName);
                            submittedCounts.push(submittedCount);
                            tooltipTableData.push(
                                submittedTables.map(item => ({
                                    name: item["Table Name"],
                                    date: item["Last Submitted Date"]
                                }))
                            );
                        }
                    });


                    // ✅ Save to ref
                    doughnutChartDataRef.current = {
                        labels,
                        submittedCounts,
                        tooltipTableData,
                        allDepartmentData,
                    };

                    // ✅ Draw doughnut chart
                    drawITDoughnutChart(labels, submittedCounts, tooltipTableData, allDepartmentData);
                    setIsLoading(false);
                    return;

                }


                if (!allDepartmentData) {
                    setIsEmptySummary(true);
                    setIsLoading(false);
                    return;
                }
                // 👇 Non-IT logic: only for the user's department
                const deptData = allDepartmentData[dept];
                const submitted = deptData[0]?.["Submitted Tables"] || [];
                const modified = deptData[1]?.["Modified Tables"] || [];
                const submittedCount = deptData[0]?.["Submitted Table count"] || 0;
                const modifiedCount = deptData[1]?.["Modified Table count"] || 0;

                const isEmpty = submitted.length === 0 && modified.length === 0;

                setIsEmptySummary(isEmpty);
                setSubmittedTables(submitted);
                setModifiedTables(modified);

                if (isEmpty) {
                    setIsLoading(false);
                    return;
                }

                setChartDataReady({
                    labels: ["Submitted", "Modified"],
                    detailData: [submittedCount, modifiedCount],
                    tooltipTableNames: [
                        submitted.map(item => ({ name: item["Table Name"], date: item["Last Submitted Date"] })),
                        modified.map(item => ({ name: item["Table Name"], date: item["Last Modified Date"] })),
                    ]
                });
                setIsLoading(false);
            } catch (err) {
                console.error("❌ Failed to fetch maker template details:", err);
                setIsLoading(false);
            }
        };
        fetchAllMakerTemplateDetails();
    }, [reloadChart]);

    useEffect(() => {
        const role = localStorage.getItem("userRole");

        if (role === "Maker" && location.state?.showLoginSuccessModal === true) {
            setShowLoginModal(true);
            window.history.replaceState({}, document.title);

            // Call due date checker
            checkUploadDueDate();
        }
    }, []);


    const drawITDoughnutChart = (labels, submittedCounts, tooltipData, allDepartmentData) => {
        const canvas = createdTemplateChartRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        // Destroy previous chart instance
        if (createdTemplateChartInstance.current) {
            createdTemplateChartInstance.current.destroy();
            createdTemplateChartInstance.current = null;
        }

        const totalSubmitted = submittedCounts.reduce((sum, val) => sum + val, 0);
        const colors = [
            "#ff6384", "#36a2eb", "#cc65fe", "#ffce56",
            "#ff9f40", "#4bc0c0", "#9966ff", "#c9cbcf"
        ];

        const templateData = {
            labels,
            datasets: [{
                data: submittedCounts,
                backgroundColor: colors.slice(0, submittedCounts.length),
                borderColor: "#ffffff",
                borderWidth: 1,
            }],
            totalUsers: totalSubmitted,
        };

        createdTemplateChartInstance.current = new Chart(ctx, {
            type: "doughnut",
            data: templateData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        align: 'center',
                        labels: {
                            color: 'black',
                            font: {
                                size: 10,
                                weight: 'normal',
                                family: 'Arial, sans-serif',
                            },
                            boxWidth: 15,
                            padding: 10,
                            useBorderRadius: false,
                            generateLabels(chart) {
                                const dataset = chart.data.datasets[0];
                                const labels = chart.data.labels;
                                return labels.map((label, i) => ({
                                    text: `${label} (${dataset.data[i]})`,
                                    fillStyle: dataset.backgroundColor[i],
                                    strokeStyle: 'transparent',
                                    lineWidth: 0,
                                    hidden: !chart.isDatasetVisible(0),
                                    index: i,
                                }));
                            },
                        },
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            title: (context) => context[0].label,
                            label: (context) => `Submitted Tables: ${context.parsed}`,
                        },
                    },
                },
                elements: {
                    arc: {
                        borderWidth: 0,
                    },
                },
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;

                        const selectedDept = labels[index];
                        // ✅ NEW: fetch full dept data from stored allDepartmentData
                        const deptData = allDepartmentData[selectedDept] || [];


                        const submitted = deptData[0]?.["Submitted Tables"] || [];
                        const modified = deptData[1]?.["Modified Tables"] || [];
                        const submittedCount = deptData[0]?.["Submitted Table count"] || 0;
                        const modifiedCount = deptData[1]?.["Modified Table count"] || 0;

                        const isEmpty = submitted.length === 0 && modified.length === 0;

                        if (!isEmpty) {
                            setChartDataReady({
                                labels: ["Submitted", "Modified"],
                                detailData: [submittedCount, modifiedCount],
                                tooltipTableNames: [
                                    submitted.map(item => ({
                                        name: item["Table Name"],
                                        date: item["Last Submitted Date"]
                                    })),
                                    modified.map(item => ({
                                        name: item["Table Name"],
                                        date: item["Last Modified Date"]
                                    }))
                                ]
                            });
                            setShowChart(true); // show bar chart next
                            setShowDoughnut(false);
                        }
                    }
                }
            },
            plugins: [
                {
                    id: 'centerText',
                    beforeDraw(chart) {
                        const { ctx, chartArea, data } = chart;
                        const total = data.totalUsers || 0;

                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';

                        ctx.font = '20px Arial';
                        ctx.fillStyle = 'black';
                        ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);

                        ctx.font = '30px Arial';
                        ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);

                        ctx.restore();
                    },
                },
                {
                    id: 'segment3DEffect',
                    afterDatasetDraw(chart) {
                        const { ctx } = chart;
                        const meta = chart.getDatasetMeta(0);
                        const dataset = chart.data.datasets[0];

                        ctx.save();

                        meta.data.forEach((arc, index) => {
                            const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;

                            const baseColor = dataset.backgroundColor[index];
                            const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
                            gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
                            gradient.addColorStop(0.5, baseColor);
                            gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

                            ctx.fillStyle = gradient;

                            ctx.beginPath();
                            ctx.moveTo(x, y);
                            ctx.arc(x, y, outerRadius, startAngle, endAngle);
                            ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                            ctx.closePath();
                            ctx.fill();

                            ctx.shadowColor = 'rgba(0,0,0,0.08)';
                            ctx.shadowBlur = 3;
                            ctx.shadowOffsetX = 1;
                            ctx.shadowOffsetY = 1;

                            ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
                            ctx.lineWidth = 1;
                            ctx.beginPath();
                            ctx.arc(x, y, outerRadius, startAngle, endAngle);
                            ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                            ctx.closePath();
                            ctx.stroke();

                            ctx.shadowColor = 'transparent';
                            ctx.shadowBlur = 0;
                            ctx.shadowOffsetX = 0;
                            ctx.shadowOffsetY = 0;
                        });

                        ctx.restore();
                    },
                },
                {
                    id: 'segmentCounts',
                    afterDatasetDraw(chart) {
                        const { ctx } = chart;
                        const dataset = chart.data.datasets[0];
                        const meta = chart.getDatasetMeta(0);

                        ctx.save();
                        ctx.fillStyle = 'black';
                        ctx.font = 'bold 14px Arial';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';

                        meta.data.forEach((arc, index) => {
                            const { x, y } = arc.tooltipPosition();
                            const value = dataset.data[index];
                            ctx.fillText(value, x, y);
                        });

                        ctx.restore();
                    },
                },
            ],
        });

        setShowChart(true);
        setShowDoughnut(true);  // Show doughnut

    };




    // ✅ Render chart AFTER canvas is mounted
    useEffect(() => {
        if (!showChart || !chartDataReady || !createdTemplateChartRef.current) return;

        const timeout = setTimeout(() => {
            const canvas = createdTemplateChartRef.current;
            if (!canvas) {
                console.warn("⚠️ Chart canvas not found after delay");
                return;
            }

            const ctx = canvas.getContext("2d");
            if (!ctx) {
                console.warn("⚠️ Canvas context not available");
                return;
            }

            // Destroy any previous chart
            if (createdTemplateChartInstance.current) {
                createdTemplateChartInstance.current.destroy();
                createdTemplateChartInstance.current = null;
            }

            // Gradients
            const gradient1 = ctx.createLinearGradient(0, 0, 0, 300);
            gradient1.addColorStop(1, "#07beb8");
            gradient1.addColorStop(0, "#967aa1");

            const gradient2 = ctx.createLinearGradient(0, 0, 0, 300);
            gradient2.addColorStop(1, "#f25c54");
            gradient2.addColorStop(0, "#967aa1");

            const { labels, detailData, tooltipTableNames } = chartDataReady;

            createdTemplateChartInstance.current = new Chart(ctx, {
                type: "bar",
                data: {
                    labels: labels.map((label, i) => `${label} (${detailData[i]})`),
                    datasets: [{
                        data: detailData,
                        backgroundColor: [gradient1, gradient2],
                        borderRadius: 6,
                        barPercentage: 0.5,
                        categoryPercentage: 0.5,
                    }],
                },
                options: {
                    onClick: (event, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            setSelectedBarData({
                                title: labels[index],
                                count: detailData[index],
                                data: tooltipTableNames[index] || [],
                            });
                            setShowChart(false);
                        }
                    },
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            enabled: true,
                            callbacks: {
                                title: (context) => context[0].label.split(" (")[0],
                                label: (context) => `Count: ${context.parsed.y}`,
                            },
                        },
                    },
                    scales: {
                        x: {
                            ticks: { color: "black" },
                            grid: { display: false },
                            title: {
                                display: true,
                                text: "Activity",
                                color: "black",
                                font: { size: 14, weight: "bold" },
                            },
                        },
                        y: {
                            beginAtZero: true,
                            ticks: { color: "black", stepSize: 1, precision: 0 },
                            grid: { color: "rgba(0,0,0,0.05)" },
                            title: {
                                display: true,
                                text: "Count",
                                color: "black",
                                font: { size: 14, weight: "bold" },
                            },
                        },
                    },
                },
                plugins: [{
                    id: "bar3DEffect",
                    afterDatasetDraw(chart) {
                        const { ctx } = chart;
                        const meta = chart.getDatasetMeta(0);
                        const dataset = chart.data.datasets[0];

                        ctx.save();
                        meta.data.forEach((bar, i) => {
                            const { x, y, base } = bar;
                            const width = bar.width;
                            const height = base - y;
                            const left = x - width / 2;
                            const top = y;

                            const baseColor = dataset.backgroundColor[i];
                            ctx.fillStyle = baseColor;
                            ctx.fillRect(left, top, width, height);

                            ctx.strokeStyle = i === 0
                                ? "rgba(100, 20, 40, 0.2)"
                                : "rgba(100, 110, 60, 0.2)";
                            ctx.lineWidth = 1;
                            ctx.strokeRect(left, top, width, height);
                        });
                        ctx.restore();
                    },
                }],
            });

            chartInitializedRef.current = true;
            setIsLoading(false);
        }, 100); // Delay ensures canvas is mounted

        return () => clearTimeout(timeout); // Cleanup on unmount/change
    }, [chartDataReady, showChart]);
    // ✅ Handle back to summary
    useEffect(() => {
        console.log("Canvas ref status on mount:", createdTemplateChartRef.current);
    }, []);


    useEffect(() => {
        setReloadChart(prev => !prev); // Toggle to re-run useEffect
    }, [dateFilter]);



    const formatTableName = (name) =>
        name
            ?.replace(/^[^_]+_/, "")
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase()) || "n/a";

    const formatDate = (dateString) => {
        if (!dateString) return "n/a";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };


    const getDateLabel = (type) =>
        type === "Submitted" ? "Last Submitted Date" : "Last Modified Date";

    const handleBackToSummary1 = () => {
        if (createdTemplateChartInstance.current) {
            createdTemplateChartInstance.current.destroy();
            createdTemplateChartInstance.current = null;
        }

        chartInitializedRef.current = false;
        setSelectedBarData(null);
        setShowChart(true);
        setShowDoughnut(false); // make sure doughnut doesn't render
    };

    const handleBackToDoughnut = () => {
        if (createdTemplateChartInstance.current) {
            createdTemplateChartInstance.current.destroy();
            createdTemplateChartInstance.current = null;
        }

        chartInitializedRef.current = false;
        setSelectedBarData(null);

        const stored = doughnutChartDataRef.current;

        if (stored) {
            drawITDoughnutChart(
                stored.labels,
                stored.submittedCounts,
                stored.tooltipTableData,
                stored.allDepartmentData
            );
        }

        setShowChart(true);     // optional
        setShowDoughnut(true);  // show doughnut again
    };



    const filterDataByDateRange = (data, range) => {
        if (range === "All") return data;

        const now = new Date();
        const thresholdDate = new Date();
    };

    const handleMQem = (e) => {
        e.preventDefault();
        navigate('/gapsyMqem');
        // Additional logic if needed
    };

    const handleBulkUpload = (e) => {
        e.preventDefault();
        navigate('/GapsyBDMupload');
    }

    const hadleModifyRejectData = (e) => {
        e.preventDefault();
        navigate('/gapsyQERejectData');
    }
    const hadleModifyApproveData = (e) => {
        e.preventDefault();
        navigate('/gapsyQEApproveData');
    }

    const handleAutomatedData = (e) => {
        e.preventDefault();
        navigate('/gapsyAutomatedupload');
    }

    useEffect(() => {
        // Define the async function inside useEffect
        const fetchNotifications = async () => {
            try {
                let csrfToken = sessionStorage.getItem("tokenizedSession");
                const config = {
                    headers: {
                        "userId": localStorage.getItem('userid'),
                        "x-csrf-token": csrfToken
                    },
                    withCredentials: true
                };


                const response = await axios.post(NotifyApi, {}, config);

                const fetchedNotifications = response.data || {};

                setNotifications(fetchedNotifications.notifications || []);
                setNotificationCount(fetchedNotifications.countOfNewNotifications || 0);

                if (fetchedNotifications.notifications && fetchedNotifications.notifications.length > 0) {
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
            }
        };

        // Call immediately when component mounts
        fetchNotifications();
        // Set up polling every 60 seconds (optional)
        const intervalId = setInterval(fetchNotifications, 60000);

        // Cleanup function to clear interval when component unmounts
        return () => clearInterval(intervalId);
    }, []);


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>

                            </ol>
                        </nav>
                    </div>
                    <div className="dropdown ms-auto mt-2 mt-md-0">
                        <button className="btn btn-outline-dark btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Quick Links
                        </button>
                        <ul className={`dropdown-menu dropdown-menu-end ${styles.dropdownMenu}`}>
                            <li>
                                <a onClick={hadleModifyRejectData} className={`dropdown-item small ${styles.dropdownItem}`} href="#">
                                    <i className="bi bi-pencil-square me-2"></i>Modify Rejected Data
                                </a>
                            </li>
                            <li>
                                <a onClick={hadleModifyApproveData} className={`dropdown-item small ${styles.dropdownItem}`} href="#">
                                    <i className="bi bi-clock-history me-2"></i>Modify Historical Data
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="mb-2">
                                            <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Maker Work Area</h6>
                                            <div id="group1" className="row">
                                                <div className="col-4 mb-1">
                                                    <div
                                                        className={`${styles.customBox} ${styles.csBoxMain} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                    >
                                                        <a onClick={handleMQem} href="#" className="text-decoration-none text-reset d-block">
                                                            <i class="bi bi-input-cursor-text"></i><br />
                                                            2.1 Quick Entry
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-4 mb-1">
                                                    <div className={`${styles.customBox} ${styles.csBoxBlue} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top">
                                                        <a onClick={handleBulkUpload} className="text-decoration-none text-reset d-block">
                                                            <i class="bi bi-file-earmark-arrow-up"></i><br />
                                                            2.2 Bulk Upload
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-4 mb-1">
                                                    <div className={`${styles.customBox} ${styles.csBoxDarkGreen} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top">
                                                        <a onClick={handleAutomatedData} className="text-decoration-none text-reset d-block">
                                                            <i class="bi bi-arrow-repeat"></i><br />
                                                            2.3 Automated Data Load
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div
                                            style={{
                                                backgroundImage: `url(${greenbg})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                borderRadius: '20px',
                                                paddingTop: '6px',
                                                paddingBottom: '6px',
                                                paddingLeft: '20px',
                                                paddingRight: '20px',
                                                width: '100%',
                                                height: '170px',
                                                marginTop: '20px',
                                            }}
                                        >

                                            <h6 className={`pb-1 mb-4 ${styles.borderBottom}`}>Gapsphere Workflow</h6>
                                            <div className={`row ${styles.group3}`}>
                                                <div className="col-4 mb-1">
                                                    <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                                                        <div className="template-text">1. Template Creation</div>
                                                        <div className="template-icon">
                                                            <i className="bi bi-file-earmark-plus"></i>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-4 mb-1">
                                                    <div className={`${styles.customtemplatebox} ${styles.highlightGlow} ${styles.activeBox} ${styles.box}`}>
                                                        <div className="template-text">2. Data Submission</div>
                                                        <div className="template-icon2">
                                                            <i className="bi bi-journals"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4 mb-1">
                                                    <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                                                        <div className="template-text">3. Data Review</div>
                                                        <div className="template-icon3">
                                                            <i className="bi bi-check-circle"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <canvas
                                        id="hiddenMakerChart"
                                        width={400}
                                        height={300}
                                        style={{ display: "none" }}
                                    ></canvas>
                                    <div className="card-body">
                                        {/* Header Section */}
                                        <div
                                            className="d-flex align-items-center justify-content-between mb-2"
                                            style={{ borderBottom: "1px solid black" }}
                                        >
                                            <h6 className="pb-0 mb-0">Data Summary</h6>
                                            <div className="d-flex align-items-center gap-2">
                                                {(selectedBarData || (!showChart && !isEmptySummary)) && (
                                                    <button
                                                        className="btn btn-white btn-sm d-flex align-items-center"
                                                        onClick={handleBackToSummary1}
                                                        title="Back to Templates Chart"
                                                        style={{ padding: "2px 4px" }}
                                                    >
                                                        <i className="bi bi-arrow-left-circle" style={{ fontSize: "10px", color: "black" }}></i>
                                                    </button>
                                                )}

                                                {dept === "IT" && !showDoughnut && !selectedBarData && (
                                                    <button
                                                        className="btn btn-white btn-sm d-flex align-items-center"
                                                        onClick={handleBackToDoughnut}
                                                        title="Back to dhougnut"
                                                        style={{ padding: "2px 4px" }}
                                                    >
                                                        <i className="bi bi-arrow-left-circle" style={{ fontSize: "10px", color: "black" }}></i>
                                                    </button>
                                                )}

                                            </div>
                                        </div>

                                        {/* Body Section */}
                                        {isLoading ? (
                                            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                                                <span className="mt-2 text-muted">Loading chart</span>
                                                <img src={loadingGif} alt="Loading..." style={{ width: '60px', height: '60px' }} />
                                            </div>
                                        ) : isEmptySummary ? (
                                            <div>
                                                <p className="text-center py-5">No activity(s) performed by the User</p>
                                            </div>
                                        )

                                            : selectedBarData ? (
                                                <div className={`tableWrapper mb-3 ${tableStyles.notificationWrapper}`}>
                                                    {/* Section Title & Count */}
                                                    <h5
                                                        style={{
                                                            marginBottom: "4px",
                                                            textTransform: "capitalize",
                                                            fontSize: "0.9rem",
                                                        }}
                                                    >
                                                        <span style={{ fontWeight: "bold" }}>{selectedBarData.title}</span>
                                                        <span style={{ fontWeight: "bold", marginLeft: "5px" }}>
                                                            - {filterDataByDateRange(selectedBarData.data, selectedRange).length}
                                                        </span>
                                                    </h5>

                                                    <hr
                                                        style={{
                                                            margin: "4px 0 8px 0",
                                                            borderColor: "black",
                                                            borderTopWidth: "1px",
                                                        }}
                                                    />

                                                    {/* Table */}
                                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                        <tbody>
                                                            {filterDataByDateRange(selectedBarData.data, selectedRange).map(
                                                                (item, index) => {
                                                                    const name = formatTableName(item.name);
                                                                    const timestamp = formatDate(item.date);
                                                                    return (
                                                                        <React.Fragment key={index}>
                                                                            <tr>
                                                                                <td
                                                                                    style={{
                                                                                        fontSize: "0.75rem",
                                                                                        fontWeight: "bold",
                                                                                        paddingBottom: "2px",
                                                                                    }}
                                                                                >
                                                                                    {name}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td
                                                                                    style={{
                                                                                        fontSize: "0.7rem",
                                                                                        paddingBottom: "4px",
                                                                                    }}
                                                                                >
                                                                                    {getDateLabel(selectedBarData.title)} : {timestamp}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td>
                                                                                    <hr
                                                                                        style={{
                                                                                            margin: "4px 0",
                                                                                            borderColor: "black",
                                                                                            borderTopWidth: "1px",
                                                                                        }}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        </React.Fragment>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )
                                                : showDoughnut ? (
                                                    <div style={{ position: "relative", height: "280px" }}>
                                                        <canvas ref={createdTemplateChartRef} height="300" />
                                                    </div>
                                                ) : showChart ? (
                                                    <div ref={chartContainerRef} style={{ position: "relative", height: "280px" }}>
                                                        <canvas ref={createdTemplateChartRef} height="300"></canvas>
                                                    </div>
                                                ) : null}

                                    </div>
                                </div>
                            </div>

                            <Modal
                                show={showDueAlertModal}
                                onHide={() => setShowDueAlertModal(false)}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: "#366872",
                                        color: "white",
                                        padding: "0.5rem 1rem",
                                    }}
                                    closeButton
                                >
                                    <Modal.Title style={{ fontSize: "16px" }}>
                                        Upload Pending Alert
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: "0.75rem 1rem", fontSize: "14px" }}>
                                    <p>{dueAlertMessage}</p>
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: "none" }}>
                                    <Button
                                        variant="primary"
                                        onClick={() => setShowDueAlertModal(false)}
                                    >
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <div class="col-lg-3 col-md-12">
                                <div class={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <h6 className={`pb-1 ${styles.borderBottom}`}>
                                            Pending Activities
                                        </h6>
                                        <div className={`tableWrapper ${tableStyles.notificationWrapper}`}>
                                            {(() => {
                                                // First filter out the notifications we don't want to show
                                                const filteredNotifications = notifications.filter(
                                                    (notification) => !["Created a Template", "Updated a Template", "Submitted a Data", "Modified a Data"].includes(notification.CompletedActivity)
                                                );

                                                // Use a Map to ensure distinct notifications
                                                const distinctNotifications = Array.from(
                                                    filteredNotifications.reduce((map, notification) => {
                                                        const key = `${notification.userId}-${notification.CompletedActivity}-${notification.Tablename}`;
                                                        if (!map.has(key)) {
                                                            map.set(key, notification);
                                                        }
                                                        return map;
                                                    }, new Map())
                                                ).map(([_, notification]) => notification);

                                                // Then check if we have any notifications left after filtering
                                                return distinctNotifications.length > 0 ? (
                                                    <ul className="list-unstyled">
                                                        {distinctNotifications.map((notification, index) => {
                                                            // Determine icon and color based on activity type
                                                            let iconClass = "";
                                                            let iconColor = "";

                                                            if (["Rejected a Data", "Rejected a Template", "Rejected a Retrieved Data",
                                                                "Rejected a Restored Template", "Rejected a Restored Data", "Bulk Rejected Data"]
                                                                .includes(notification.CompletedActivity)) {
                                                                iconClass = "bi-pencil-square";
                                                                iconColor = "text-success";
                                                            } else {
                                                                iconClass = "bi-file-earmark-plus-fill";
                                                                iconColor = "text-success";
                                                            }

                                                            const dept = notification.Tablename.split('_')[0];
                                                            const displayTableName = notification.Tablename.includes('_')
                                                                ? notification.Tablename.split('_').slice(1).join('_')
                                                                : notification.Tablename;

                                                            const toProperCase = (str) => {
                                                                return str.replace(/_/g, ' ')
                                                                    .replace(/\w\S*/g, (word) =>
                                                                        word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
                                                                    );
                                                            };
                                                            const properTableName = toProperCase(displayTableName);

                                                            return (
                                                                <li
                                                                    key={index}

                                                                    // onClick={() => {
                                                                    //     sessionStorage.setItem('selectedDept', dept);
                                                                    //     localStorage.setItem('selectedDept', dept);
                                                                    //     localStorage.setItem('selectedTable', notification.Tablename);
                                                                    //     localStorage.setItem('selectedDataModel', notification.Datamodel);
                                                                    //     localStorage.setItem('completedActivity', notification.CompletedActivity); //  Add this
                                                                    //     localStorage.setItem('navigatedFromDashboard', 'true');

                                                                    //     if (notification.CompletedActivity === "Rejected a Past Data") {
                                                                    //         navigate("/gapsyQEApprovedata");
                                                                    //     } else {
                                                                    //         navigate("/gapsyQERejectData");
                                                                    //     }
                                                                    // }}

                                                                    onClick={() => {
                                                                        console.log("Notification:", notification);

                                                                        sessionStorage.setItem('selectedDept', dept);
                                                                        localStorage.setItem('selectedDept', dept);
                                                                        localStorage.setItem('selectedTable', notification.Tablename);
                                                                        localStorage.setItem('selectedDataModel', notification.Datamodel);
                                                                        localStorage.setItem('completedActivity', notification.CompletedActivity);
                                                                        localStorage.setItem('navigatedFromDashboard', 'true');

                                                                        console.log("Stored Table:", localStorage.getItem("selectedTable"));

                                                                        if (notification.CompletedActivity === "Rejected a Past Data") {
                                                                            navigate("/gapsyQEApprovedata");
                                                                        } else {
                                                                            navigate("/gapsyQERejectData");
                                                                        }
                                                                    }}

                                                                    className={`d-flex align-items-center mb-1 pb-1 py-2 px-2 ${styles.notificationItem} ${index < filteredNotifications.length - 1 ? styles.borderBottom : ''}`}
                                                                >
                                                                    <i className={`bi ${iconClass} ${iconColor} fs-5 me-3`}></i>
                                                                    <span>
                                                                        <strong>{notification.userId}</strong> has{' '}
                                                                        <strong><span className="text-dark">{notification.CompletedActivity}</span></strong>{' '}
                                                                        (<strong>{properTableName}</strong>).
                                                                        {["Rejected a Data", "Rejected a Template", "Rejected a Retrieved Data",
                                                                            "Rejected a Restored Template", "Rejected a Restored Data", "Bulk Rejected Data", "Rejected a Past Data"]
                                                                            .includes(notification.CompletedActivity) && (
                                                                                <> Pending for your Modification.</>
                                                                            )}
                                                                        {["Submitted a Data", "Modified a Data", "Submitted a Template",
                                                                            "Modified a Template", "Uploaded a Data", "Retrieved a Data",
                                                                            "Restored a Template", "Restored a Data", "Modified a Retrieved Data",
                                                                            "Modified a Existing Template", "Modified a Rejected Template"]
                                                                            .includes(notification.CompletedActivity) && (
                                                                                <> Pending for your Review.</>
                                                                            )}
                                                                    </span>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                ) : (
                                                    <p className="text-center py-5">No activity(s) Pending with User</p>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Mdashboard;
